/*
  定义modules中用到的action。
  命令规则：
    模块名_属性名_操作(FETCH、QUERY等)   ！！！ 所有字母大写 作为常量导出
  属性名尽可能与modules.state中属性名一致，并且直观容易理解，否则请在该行后用 // 注释。
*/

/* app modules */

/* -------------------------------------------------------------------------------------------------------- */

/*
  定义modules中用到的mutation。
  命令规则：
    操作名[SET, UPDATE, REMOVE]_模块名_属性名   ！！！ 所有字母大写 作为常量导出
  属性名尽可能与modules.state中属性名一致，并且直观容易理解，否则请在该行后用 // 注释。
*/

/* app modules */
export const OLMAP_BASEMAPINIT = 'OLMAP_BASEMAPINIT';
export const OLMAP_CHARTTYPE = 'OLMAP_CHARTTYPE';
export const OLMAP_MAPSPECIAL = 'OLMAP_MAPSPECIAL';
export const OLMAP_MAPTABLETYPE = 'OLMAP_MAPTABLETYPE';



// WEBPACK FOOTER //
// ./src/store/types.js